export class OperadorEntity {
    constructor() {
    }


    public id: any = null;
    public name: any = null;
    public ruc: any = null;
    public logo: any = null;
    public nameshort: any = null;
    public icon: any = null;
}
